import React, { useState, useEffect } from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';

let dummy_data=[
    {
        'Storage conditions':'Granlipid RSC should be stored in closed containers. Do Not Exceed Room Temperature (22°C).',
        'Shelf life':'12 Months',
    }
]
export default function Store_Conditions(){
    return (
      <div className=" report_id_tables card">
        <DataTable
          value={[]}
          showGridlines
          className="page_table_font_size"
        >
          <Column
            field="Storage conditions"
            header="Storage conditions"
          ></Column>
          <Column field="Shelf life" header="Shelf life"></Column>
        </DataTable>
      </div>
    );
}

